import { useNavigate } from 'react-router-dom'
import Icon from '../icon'

export const BackButton = ({
  className,
  onClick,
  text = 'Back',
}: {
  className?: string
  onClick?: () => void
  text?: string
}) => {
  const navigate = useNavigate()

  return (
    <button
      type="button"
      onClick={() => {
        if (onClick) {
          onClick()
        } else {
          navigate(-1)
        }
      }}
      className={`
        soft-shrink w-fit text-left
        flex items-center
        gap-2 font-medium
        text-sm
        ${className}
        `}
    >
      <Icon id={'left-caret'} width={12} height={12} />
      <span>{text}</span>
    </button>
  )
}
